/* eslint-disable deprecation/deprecation */
/* istanbul ignore file */
import noop from 'lodash/noop';

import { get } from '@lumapps/constants';

import { RouterApi } from '../api';
import { createUrl } from '../utils';

/**
 * Performs a full-page (cross-app / cross-instance) redirect.
 * Injected from the legacy app so it can run the legacy unsaved-changes
 * confirmation before leaving the page (see `injectRouter`).
 */
type HardRedirect = (url: string, options?: { shouldSkipLegacyChangeConfirm?: boolean }) => void;

let go: any = noop;
let hardRedirect: HardRedirect | undefined;

export function injectRouter(options: { go?: any; hardRedirect?: HardRedirect }) {
    if (options.go) {
        go = options.go;
    }
    if (options.hardRedirect) {
        hardRedirect = options.hardRedirect;
    }
}

const { applicationId } = get();

export const angularApi: RouterApi = {
    getUrl: createUrl,
    redirect: (route, { openInNewTab, shouldSkipLegacyChangeConfirm } = {}) => {
        const { appId, legacyId, params = {}, anchor, legacyForceReload, instanceSlug } = route;

        if (openInNewTab) {
            // Open in new tab.
            window.open(createUrl(route), undefined, 'noopener noreferrer');
            return;
        }

        if (anchor) {
            params['#'] = anchor;
        }

        if (appId === applicationId && !instanceSlug) {
            setTimeout(() => {
                go(legacyId, params, { reload: legacyForceReload, shouldSkipLegacyChangeConfirm });
            }, 0);
        } else {
            const url = createUrl(route);
            // A full-page redirect (route on another app or instance) does not go through the
            // Angular `$stateChangeStart` guard, so it must run the legacy unsaved-changes
            // confirmation itself when one was injected by the legacy app.
            if (hardRedirect) {
                hardRedirect(url, { shouldSkipLegacyChangeConfirm });
            } else {
                window.location.href = url;
            }
        }
    },
};
